import React, { useState } from 'react';
import { ChromePicker } from 'react-color';
import styled from 'styled-components';
import PropTypes from 'prop-types';

export const ColorPicker = ({
  colorChangeHandler,
  width,
  height,
  initialColor = 'linear-gradient(140deg, #ffb748, #ff687b, #b6a9f1, #4fd4c0, #42b2ee, #8da0ab)',
  popoverStyle,
  swatchStyle,
  title,
  children,
}) => {
  const [colorPicker, setColorPicker] = useState(false);
  const [color, setColor] = useState(initialColor);

  const handleClick = () => {
    setColorPicker(!colorPicker);
  };

  const handleClose = () => {
    setColorPicker(false);
  };

  const handleChange = newColor => {
    setColor(newColor.hex);
    colorChangeHandler(newColor.hex);
  };

  return (
    <Wrapper>
      <SwatchWrapper
        onClick={handleClick}
        swatchStyle={swatchStyle}
        title={title}
      >
        <Swatch>
          <Color color={color} width={width} height={height} />
        </Swatch>
        {children}
      </SwatchWrapper>

      {colorPicker && (
        <Popover popoverStyle={popoverStyle}>
          <Cover onClick={handleClose} />
          <ChromePicker
            color={color}
            disableAlpha={true}
            onChange={handleChange}
          />
        </Popover>
      )}
    </Wrapper>
  );
};

ColorPicker.propTypes = {
  initialColor: PropTypes.string,
  colorChangeHandler: PropTypes.func,
  width: PropTypes.string,
  height: PropTypes.string,
  popoverStyle: PropTypes.array,
  swatchStyle: PropTypes.array,
  children: PropTypes.node,
  title: PropTypes.string,
};

const Swatch = styled.div`
  width: 100%;
  height: 100%;
  padding: 4px;
  background: #fff;
  border-radius: 4px;
  box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.1);
  display: inline-block;
  cursor: pointer;
`;

const SwatchWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 5px;
  :hover {
    opacity: 0.8;
  }
  ${props => props.swatchStyle};
`;

const Popover = styled.div`
  position: absolute;
  position: -ms-page;
  z-index: 2;
  ${props => props.popoverStyle};
`;

const Cover = styled.div`
  position: fixed;
  top: 0px;
  right: 0px;
  bottom: 0px;
  left: 0px;
`;

const Wrapper = styled.div`
  height: 100%;
`;

const Color = styled.div.attrs(props => ({
  style: {
    background: props.color,
  },
}))`
  width: ${props => props.width || '100%'};
  height: ${props => props.height || '100%'};
  border-radius: 2px;
`;
